const customStyles: any = {
    option: (provided: any, state: any) => {
        return {
            ...provided,
            fontSize: '13px',
            padding: '4px 12px',
            backgroundColor: state.isSelected ? "#008964" : "white",

        }
    },
    indicatorSeparator: (provided: any, state: any) => { },
    indicatorsContainer: (provided: any, state: any) => {
        return {
            ...provided,
            height: 27,
            padding: 0,

        }
    },
    control: (provided: any, state: any) => {
        return {
            ...provided,
            minHeight: 35,
            border: state.isFocused ? "1px solid #e4e4e4" : "1px solid #e4e4e4",
            height: 30,
            width: "100%",
            fontSize: '13px',
            backgroundColor: '#f7f7f7',
            borderRadius: 0,
            borderColor: state.isFocused && "",
            boxShadow: state.isFocused ? 0 : 0,
            "text-align-last": "left",
            // "outline-style": state.isFocused ? "none" : "",
            //"border-left": state.isFocused ? "2px solid #008964" : "2px solid #e4e4e4",
            // "border-bottom": state.isFocused ? "1px solid #bae6da" : "",
            // "border-top": state.isFocused ? "1px solid #bae6da" : "",
            // "border-right": state.isFocused ? "1px solid #bae6da" : "",
            '&:hover': {
                border: '0 !important',
                //"outline-style": "none !important",
                //"border-left": "2px solid #008964 !important",
                //"border-bottom": "1px solid #bae6da !important",
                //"border-top": "1px solid #bae6da !important",
                //"border-right": "1px solid #bae6da !important",
            },
            selectProps: {
                backgroundColor: "#008964",
            }
        }
    },
    menu: (provided: any, state: any) => {
        return {
            ...provided,
            borderRadius: 0,
        }
    },
    placeholder: (provided: any, state: any) => {
        return {
            ...provided,
            "text-align": "center",
        }
    },
    singleValue: (provided: any, state: any) => {
        return {
            ...provided,
            opacity: state.isDisabled ? 0.5 : 1,
            transition: 'opacity 300ms',
        }
    },
}

const GetDataPost = (data: ICVS) => {
    const result: ICVSBizagiPost =
    {
        id_case: data.IDBizagi ?? '',
        id_cliente: data.IDCliente ?? '',
        data: JSON.stringify(data)
    }
    return result;
}


export { customStyles, GetDataPost };